export default __webpack_public_path__ + "624beb0a986cf1ec391d487aa25080ad.png";